var { map, size, each, randomString } = require('./common.js')

const DELI = '-[/]-'

class Pubsub {
	constructor () {
		this.listeners = []
		this.destroyed = false
	}

	destroy () {
		this.destroyed = true
	}

	publish (topic, payload, payload2, payload3) {
		if (this.destroyed) return
		each(this.listeners[topic], cb => cb(payload, payload2, payload3))
	}

	only (topic, cb) {
		if (this.destroyed) return
		var subid = topic + DELI + randomString(20)
		if (!this.listeners[topic]) this.listeners[topic] = {}
		this.listeners[topic] = { subid: cb }
		return subid
	}

	count (topic) {
		return size(this.listeners[topic])
	}

	on2 (obj, topic, cb) {
		if (this.destroyed) return
		var subid = topic + DELI + randomString(20)
		if (!this.listeners[topic]) this.listeners[topic] = {}
		this.listeners[topic][subid] = cb
		obj.___pubsubsubs = obj.___pubsubsubs || []
		obj.___pubsubsubs.push(subid)
		if (obj.$once) obj.$once('hook:beforeDestroy', () => this.un2(obj))
		return cb
	}

	on (topic, cb) {
		if (this.destroyed) return
		var subid = topic + DELI + randomString(20)
		if (!this.listeners[topic]) this.listeners[topic] = {}
		this.listeners[topic][subid] = cb
		return subid
	}

	un2 (obj) {
		if (this.destroyed) return
		map(obj.___pubsubsubs, subid => {
			if (!subid) return
			var topic = subid.split(DELI)[0]
			if (!this.listeners[topic]) return
			delete this.listeners[topic][subid]
		})
		obj.___pubsubsubs = []
	}

	un (subid) {
		if (this.destroyed) return
		if (!subid) return
		var topic = subid.split(DELI)[0]
		if (!this.listeners[topic]) return
		delete this.listeners[topic][subid]
	}
}

module.exports = Pubsub
